import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ShareIcon = function ShareIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "ShareIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11.271 2.51c-.618 0-1.138.511-1.138 1.166 0 .656.52 1.167 1.138 1.167s1.138-.511 1.138-1.167c0-.655-.52-1.167-1.138-1.167M8.624 3.675C8.624 2.21 9.798 1 11.27 1s2.647 1.21 2.647 2.676c0 1.468-1.174 2.677-2.647 2.677a2.62 2.62 0 0 1-1.892-.805L7.13 7.071a2.7 2.7 0 0 1 0 1.859l2.249 1.522a2.62 2.62 0 0 1 1.892-.804c1.473 0 2.647 1.209 2.647 2.676S12.744 15 11.271 15s-2.647-1.209-2.647-2.676q0-.27.051-.526l-2.443-1.654c-.44.334-.988.532-1.585.532C3.174 10.676 2 9.467 2 8s1.174-2.676 2.647-2.676c.597 0 1.145.198 1.585.532l2.443-1.654a2.7 2.7 0 0 1-.051-.526M4.647 6.833C4.03 6.833 3.51 7.345 3.51 8c0 .656.52 1.167 1.138 1.167S5.785 8.656 5.785 8c0-.655-.52-1.167-1.138-1.167m6.624 4.324c-.618 0-1.138.511-1.138 1.167 0 .655.52 1.167 1.138 1.167s1.138-.512 1.138-1.167c0-.656-.52-1.167-1.138-1.167",
      clipRule: "evenodd"
    })
  }));
};

export { ShareIcon };
